import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import Employees from './pages/Employees';
import Assignments from './pages/Assignments';
import Expenses from './pages/Expenses';
import Income from './pages/Income';
import Reports from './pages/Reports';
import Users from './pages/Users';
import ActivityLogs from './pages/ActivityLogs';
import Settings from './pages/Settings';
import PendingUser from './pages/PendingUser';
import InactiveUser from './pages/InactiveUser';
import IncomeHistory from './pages/IncomeHistory';
import Zakat from './pages/Zakat';
import Allocations from './pages/Allocations';
import Analytics from './pages/Analytics';
import Debts from './pages/Debts';
import ClientInvoices from './pages/ClientInvoices';
import Akts from './pages/Akts';
import IncomeEstimates from './pages/IncomeEstimates';
import Payouts from './pages/Payouts';
import AuthCallback from './components/AuthCallback';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { Toaster } from 'sonner';
import './App.css';

function AppRouter() {
  const location = useLocation();
  
  // Check for auth error in URL (from OAuth callback redirects)
  if (location.search?.includes('error=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/pending" element={<PendingUser />} />
      <Route path="/inactive" element={<InactiveUser />} />
      
      {/* Protected routes with layout */}
      <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="projects" element={<Projects />} />
        <Route path="projects/:projectId" element={<ProjectDetail />} />
        <Route path="employees" element={<Employees />} />
        <Route path="assignments" element={<Assignments />} />
        <Route path="expenses" element={<Expenses />} />
        <Route path="income" element={<Income />} />
        <Route path="income-history" element={<IncomeHistory />} />
        <Route path="reports" element={<Reports />} />
        <Route path="users" element={<Users />} />
        <Route path="activity" element={<ActivityLogs />} />
        <Route path="settings" element={<Settings />} />
        <Route path="zakat" element={<Zakat />} />
        <Route path="allocations" element={<Allocations />} />
        <Route path="debts" element={<Debts />} />
        <Route path="client-invoices" element={<ClientInvoices />} />
        <Route path="akt" element={<Akts />} />
        <Route path="income-estimates" element={<IncomeEstimates />} />
        <Route path="payouts" element={<Payouts />} />
        <Route path="analytics" element={<Analytics />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-right" />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
